import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "font-bold" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "font-bold"
}

import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'
import useQuasar from 'quasar/src/composables/use-quasar.js';
import { useFileUploadStore } from '@/stores'
import { storeToRefs } from 'pinia'

import FileUploadAccordion from '../FileUploadAccordion.vue'
import FileUploadAccordionItem from '../FileUploadAccordionItem.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()

const fileUploadStore = useFileUploadStore()
const {
  showUploadDialog,
  isProcessing,
  isUploading,
  uploads,
  hasFailedUploads,
  waitingUploads,
  ongoingUploads,
  failedUploads,
} = storeToRefs(fileUploadStore)

const $q = useQuasar()
const dialogPosition = computed(() => $q.screen.lt.sm ? 'bottom' : undefined)
const totalOngoingUploads = computed(() => waitingUploads.value.length + ongoingUploads.value.length)

const isExpanded = ref(true)

function closeDialog () {
  showUploadDialog.value = false
}

function navigateToFolder (folderId) {
  router.push({
    name: 'media-manager.folder',
    params: { folderId },
  })
}

function cancelUpload (upload) {
  fileUploadStore.cancel(upload)
}

function removeUpload (selectedUpload) {
  uploads.value = uploads.value.filter(upload => upload !== selectedUpload)
}

return (_ctx: any,_cache: any) => {
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    "model-value": _unref(showUploadDialog),
    position: _unref(dialogPosition),
    class: "file-upload-dialog",
    persistent: "",
    seamless: "",
    "no-refocus": "",
    "no-shake": ""
  }, {
    default: _withCtx(() => [
      _createVNode(FileUploadAccordion, {
        modelValue: isExpanded.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isExpanded).value = $event)),
        "data-id": "file-upload-accordion",
        class: "!rounded-[5px]",
        onClose: closeDialog
      }, {
        header: _withCtx(() => [
          (_unref(isProcessing) || _unref(isUploading))
            ? (_openBlock(), _createBlock(_component_i18n_t, {
                key: 0,
                "data-id": "file-upload-accordion-header",
                keypath: "upload.uploading",
                tag: "div",
                scope: "global"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_1, [
                    _createTextVNode(_toDisplayString(_ctx.$tc('upload.files', _unref(totalOngoingUploads))) + " ", 1),
                    (_unref(hasFailedUploads))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_2, " (" + _toDisplayString(_ctx.$tc('upload.n_failed', _unref(failedUploads).length)) + ") ", 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_i18n_t, {
                key: 1,
                "data-id": "file-upload-accordion-header",
                keypath: "upload.upload_complete",
                tag: "div",
                scope: "global"
              }, {
                default: _withCtx(() => [
                  (_unref(hasFailedUploads))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_3, " (" + _toDisplayString(_ctx.$tc('upload.n_failed', _unref(failedUploads).length)) + ") ", 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
        ]),
        items: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(uploads), (upload) => {
            return (_openBlock(), _createBlock(FileUploadAccordionItem, {
              key: upload.filename,
              label: upload.filename,
              description: upload.details,
              state: upload.status,
              onNavigate: ($event: any) => (navigateToFolder(upload.folderId)),
              onCancel: ($event: any) => (cancelUpload(upload)),
              onRemove: ($event: any) => (removeUpload(upload))
            }, null, 8, ["label", "description", "state", "onNavigate", "onCancel", "onRemove"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["model-value", "position"]))
}
}

})